import { DeviceInfo } from '@/types/device-info';
import hashtable from '../assets/hashtable';
import rsa from '../assets/rsa';
import { loadGlobalScript } from '@/utils/load-script';
import * as logger from 'commercial-web-client-utilities/dist/logging/logger';

export class DeviceInfoService {
    public async getDeviceInfo(): Promise<DeviceInfo> {
        await loadGlobalScript(hashtable);
        await loadGlobalScript(rsa);

        const deviceInfo: DeviceInfo = {
            fingerprint: ' ',
        };
        // Fingerprint
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            deviceInfo.fingerprint = (window as any).encode_deviceprint();
        } catch (error: unknown) {
            logger.warn('Failed to generate device fingerprint');
        }
        return deviceInfo;
    }
}

export const deviceInfoService = new DeviceInfoService();
